import { jsx as t } from "react/jsx-runtime";
import { forwardRef as m } from "react";
import { ErrorMessage as p } from "@hookform/error-message";
function f(o, r) {
  return o && r ? !!o[r] : !1;
}
const c = (o) => {
  const r = m((n, i) => {
    const { name: e, errors: s, ...a } = n;
    return /* @__PURE__ */ t(
      o,
      {
        ...a,
        ref: i,
        name: e,
        hasError: f(s, e),
        errorMessage: /* @__PURE__ */ t(p, { errors: s, name: e ?? "" })
      }
    );
  });
  return process.env.NODE_ENV === "development" && (r.displayName = "FieldComponentWithError"), r;
};
export {
  c as withErrorMessage
};
